
import AddBooking from '@/components/AddBooking.vue'
import CalendarComponent from '@/components/CalendarComponent.vue';

import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
  components: {
    AddBooking,
    CalendarComponent
  },
  setup(){
    const store = useStore();
    const isLoggedIn = computed(() => !!store.state.token);

    return {
      isLoggedIn
    }
  }
}
